
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_swimc_hauf3_189",
  "anchor-list": "awsui_anchor-list_swimc_hauf3_221",
  "anchor-item": "awsui_anchor-item_swimc_hauf3_244",
  "anchor-item--active": "awsui_anchor-item--active_swimc_hauf3_264",
  "anchor-link": "awsui_anchor-link_swimc_hauf3_281",
  "anchor-link--active": "awsui_anchor-link--active_swimc_hauf3_323",
  "anchor-link-text": "awsui_anchor-link-text_swimc_hauf3_330",
  "anchor-link-info": "awsui_anchor-link-info_swimc_hauf3_334"
};
  